var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = !(!_vm.hasLogin || _vm.empty === true)
    ? _vm.__map(_vm.cartList, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g0 = _vm.cartList.length
        var g1 = _vm.loadedItemIds.has(item.id)
        var m0 = _vm.style(200)
        return {
          $orig: $orig,
          g0: g0,
          g1: g1,
          m0: m0,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }